<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <v-app id="inspire" class="app">
        <v-form ref="form" lazy-validation>
          <app-drawer class="app--drawer"></app-drawer>
          <app-toolbar class="app--toolbar" v-bind:class="{ 'toolbar-expanded': sidebarExpanded}"></app-toolbar>
          <v-content>
            <!-- Page Header -->
            <page-header v-if="$route.meta.breadcrumb"></page-header>
            <div class="page-wrapper">
              <router-view></router-view>
            </div>
            <!-- App Footer -->
            <v-footer height="auto" class="white pa-3 app--footer">
              <span class="caption">phanmemdathangoee.com design &copy; 2020</span>
              <v-spacer></v-spacer>
            </v-footer>
          </v-content>
          <!-- Go to top -->
          <app-fab></app-fab>
          <v-navigation-drawer
            class="setting-drawer"
            temporary
            right
            v-model="rightDrawer"
            hide-overlay
            fixed
          ></v-navigation-drawer>
          <v-snackbar transition="slide-x-transition" :timeout="snackbar.timeout ? snackbar.timeout : 3000" :color="snackbar.color" v-model="snackbar.show" bottom left multi-line rounded>
            {{ snackbar.text }}
            <template v-slot:action="{ attrs }">
              <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="snackbar.show = false"
              >
                X
              </v-btn>
            </template>
          </v-snackbar>
          <v-dialog v-model="delDialog" persistent max-width="320">
            <v-card>
              <v-card-title class="subheading">Xác nhận</v-card-title>
              <v-card-text>{{ delMessage || 'Bạn có chắc chắn muốn xóa mục đã chọn?'}}</v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="green darken-1 white--text" @click="delConfirmed">Đồng ý</v-btn>
                <v-btn color="blue darken-1 white--text" @click="delDialog = false">Hủy</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="notiDialog" persistent max-width="620">
            <v-card>
              <v-card-title class="subheading">{{ configuration.MessageTitle != '' ? configuration.MessageTitle : 'Thông báo'}}</v-card-title>
              <v-card-title class="font-italic font-weight-light">Ngày: {{ configuration.MessageDate | display_date }}</v-card-title>
              <v-card-text>{{ configuration.Message }}</v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="blue darken-1 white--text" @click="notiDialog = false">Đóng</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-form>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view :key="$route.fullpath"></router-view>
        </keep-alive>
      </transition>
    </template>
  </div>
</template>

<script>
import AppDrawer from "@/components/AppDrawer";
import AppToolbar from "@/components/AppToolbar";
import AppFab from "@/components/AppFab";
import PageHeader from "@/components/PageHeader";
import AppEvents from "./event";
import { mapState } from "vuex";
export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader
  },
  data: () => ({
    delMessage: "",
    delDialog: false,
    notiDialog: false,
    delId: 0,
    rightDrawer: false,
    snackbar: {
      show: false,
      text: "",
      color: ""
    }
  }),
  computed: {
    ...mapState("commons", {
      sidebarExpanded: "sidebarExpanded"
    }),
    ...mapState({
      configuration: state => state.configuration.selected
    }),
    authented() {
      return this.$store.state.authentication.token != '';
    },
    userRole() {
      return this.$store.state.authentication.user.roleid;
    },
  },
  watch: {
    configuration() {
      if (this.userRole == 0 && this.configuration && this.configuration.Message != '') {
        this.notiDialog = true;
      }
    },
    authented() {
      if (this.userRole === 0) {
        this.$store.dispatch("configuration/getDetail", 1);
      }
    }
  },
  methods: {
    delConfirmed() {
      this.delDialog = false;
      this.$root.$emit('CONFIRMED_REMOVE_DATA', this.delId);
    }
  },
  created() {
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
    window.getApp.$on("APP_DRAWER_TOGGLED", () => {
      this.$store.commit("commons/setSidebarExpanded", {
        expanded: !this.sidebarExpanded
      });
    });
    if(this.authented) {
      this.$store.dispatch("configuration/getDetail", 1);
    }
  }
};
</script>

<style lang="stylus" scoped>
.setting-fab {
  top: 50% !important;
  right: 0;
  border-radius: 0;
}

.page-wrapper {
  min-height: calc(100vh - 64px - 50px - 81px);
}

.toolbar-expanded {
  padding: 0 0 0 230px;
}
</style>
